import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";

export const signUp = createAsyncThunk('signUp', async ({ values }) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "first_name", values.first_name
    )
    bodyFormData.append(
        "last_name", values.last_name
    )
    bodyFormData.append(
        "gender", values.gender
    )
    bodyFormData.append(
        "dob", moment(values.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    bodyFormData.append(
        "email", values.email
    )
    bodyFormData.append(
        "password", values.password
    )
    bodyFormData.append(
        "mobile_number", values.mobile_number
    )
    bodyFormData.append(
        "profile", values.profile
    )

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'signup',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", 'type': 'profile' }
        })
        return res
    } catch (error) {
        return error.response
    }
})